<template>
  <div class="modal" data-backdrop="static" id="bsMediaPlanTargetSaveFormDialog" ref="bsMediaPlanTargetSaveFormDialog">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content viewDetails">
        <form name="saveMediaPlanTarget"
              :action="pUrls['saveMediaPlanTargetMeasures']"
              method="post" class="ajax-support show-waiting"
              data-ajax-support-csv="#ajaxModuleForm,#mediaPlanTargetListHeader,#mediaPlanTargetListBody,#campaignModuleSidebar">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span>
            </button>
            <h3 class="modal-title">{{ 'dictionary.media.plan.target.budget.title' | i18nText(pDictionary) }}</h3>
          </div>
          <div class="modal-body max-height bs3-padding-top-reset bs3-padding-bottom-reset overflow-y-hidden">

            <input type="hidden" name="dataForm.data.id" :value="data.id"/>

            <input type="hidden" name="src" :value="pSrc"/>
            <input type="hidden" name="srcId" :value="pSrcId"/>

            <div v-if="nbOfErrors > 0">
              <div class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-danger">
                <span class="label label-danger">{{ nbOfErrors | error(pDictionary) }}</span>
              </div>
            </div>

            <div class="row bs3-margin-top">
              <div class="col-xs-4">
                <div class="well well-sm">
                  <label>{{'dictionary.media.plan' | i18nText(pDictionary)}}</label>
                  <div>{{data.mediaPlanTargetRef.name}}</div>
                </div>
              </div>
              <div class="col-xs-4">
                <div class="well well-sm">
                  <label>{{'dictionary.organization.plural' | i18nText(pDictionary)}}</label>
                  <div>{{dimensionLevel1Description}}</div>
                </div>
              </div>
              <div class="col-xs-4">
                <div class="well well-sm">
                  <label>{{ 'dictionary.media.plan.target.timeline' | i18nText(pDictionary)}}</label>
                  <div>{{ 'dictionary.general.calendar.timeline.by.' + data.timelineText | i18nText(pDictionary)}}</div>
                </div>
              </div>
            </div>

            <div class="row scrollable-content scroll-y-xs noscroll-y-lg bs3-light-gray-bg" style="min-height: 80vh">
              <div class="col-xs-12 full-height-lg noscroll-y-xs scroll-y-lg col-separator-left bs3-white-bg">
                <media-plan-target-measures-matrix
                    :p-currencies="pCurrencies"
                    :p-language="pLanguage"
                    :p-dictionary="pDictionary"
                    :p-urls="pUrls"
                    :p-error-list="pErrorList"
                    :p-src="pSrc"
                    :p-src-id="pSrcId"
                    :p-thousand-delimiter="pThousandDelimiter"
                    :p-decimal-delimiter="pDecimalDelimiter"
                    :p-currency-id="pDataForm.data.currencyRef.id"
                    :p-media-plan-target-id="data.id"
                    :p-dimension-level1-token="data.dimensionLevel1TokenText"
                    :p-dimension-level1-filter-refs="data.dimensionLevel1FilterRefs"
                    :p-timeline="data.timelineText"
                    :p-measures-by-cell-id="data.measureTextsByCellId">
                </media-plan-target-measures-matrix>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-right">
              <button type="submit" class="btn btn-primary">
                <i class="fa-light fa-check"></i> <span>{{ pDictionary['dictionary.actions.save'] }}</span>
              </button>
              <a href="#"
                 class="btn btn-link" data-dismiss="modal" aria-label="Cancel">{{ pDictionary['dictionary.actions.cancel'] }}</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import refHelpers from "@/helpers/ref-helpers";
import stringHelpers from "@/helpers/string-helpers";
import MediaPlanTargetMeasuresMatrix from "@/components/modules/mediaplan-module/mediaplan-target/form-save-measures/MediaPlanTargetMeasuresMatrix";

export default {
  name: "MediaPlanTargetMeasureSaveForm",
  components: {MediaPlanTargetMeasuresMatrix},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pDataForm: Object
  },
  data: function () {
    return {
      data: this.pDataForm.data,
      errorList: []
    }
  },
  methods: {
    isIdValid: function () {
      return this.data.id !== undefined
             && this.data.id > 0;
    }
  },
  computed: {
    dimensionLevel1Description: function() {
      if(this.data.dimensionLevel1FilterRefs.length === 1)
      {
        return refHelpers.getRefName(this.data.dimensionLevel1FilterRefs[0]);
      }
      else if(this.data.dimensionLevel1FilterRefs.length > 1)
      {
        let text = stringHelpers.formatI18nText('dictionary.organization.count', this.pDictionary)
        return stringHelpers.formatI18nParams(text, 0, this.data.dimensionLevel1FilterRefs.length);
      }
      else
      {
        return stringHelpers.formatI18nText('dictionary.organization.all', this.pDictionary)
      }
    },
    timelineDescription: function() {
      return stringHelpers.formatI18nText('dictionary.organization.count', this.pDictionary)
    }
  },
  mounted: function () {
    let _component = this;

    let $bsMediaPlanTargetSaveFormDialog = $(this.$refs.bsMediaPlanTargetSaveFormDialog);
    $bsMediaPlanTargetSaveFormDialog.on('shown.bs.modal', function () {
      _component.$nextTick(function () {
        $bsMediaPlanTargetSaveFormDialog.adaptLayout();
      });
    });

    $bsMediaPlanTargetSaveFormDialog.on('hidden.bs.modal', function () {

    });

    $(_component.$refs.bsMediaPlanTargetSaveFormDialog).modal();
  }
}
</script>

<style scoped>

</style>